import { chain } from 'lodash'

import {
    AosAdUserDto,
    AosUserNotificationPreferencesDto,
} from '../../../dataaccess/users/types/AosUserDto'
import { AosAirport, notificationPreferences } from '../../flightInformation/types/AosAirport'
import { WeatherUnit, wireToWeatherUnit } from '../../statusDashboard/types/filters/WeatherUnit'
import { AosAdUser } from './AosUser'
import { AosUserBaseImpl } from './AosUserBaseImpl'
import { AosUserLocalisation } from './AosUserLocalisation'
import { AdditionalPreferenceItem } from './AosUserNotificationsPreferences'

export class AosAdUserImpl extends AosUserBaseImpl<AosAdUserDto> implements AosAdUser {
    constructor(value: AosAdUserDto) {
        super(value)
        this.mappedNotificationPreferences = this.mapNotificationPreferences(
            (this.value.notificationPreferences as AosUserNotificationPreferencesDto)?.additional,
        )
    }

    private readonly mappedNotificationPreferences: Record<
        string,
        Record<string, AdditionalPreferenceItem>
    > = {}

    public get thumbnail() {
        return this.value.thumbnail ? `data:image/png;base64,${this.value.thumbnail}` : undefined
    }

    public get unit() {
        return this.value.unit
    }

    public get alternativePhone() {
        return this.value.alternativePhoneNumber
    }

    public get notificationPreferences() {
        return {
            ...this.value.notificationPreferences,
            additional: this.mappedNotificationPreferences,
        }
    }

    private mapNotificationPreferences(
        additional: Record<string, AdditionalPreferenceItem> | undefined,
    ) {
        const grouped = {} as Record<string, Record<string, AdditionalPreferenceItem>>
        const groups = chain(notificationPreferences).entries().value()

        for (const key in additional) {
            const item = additional[key]
            const group = groups.find(([innerKey]) => innerKey === key)

            if (group) {
                const groupKey = group[1].groupName
                grouped[groupKey] = {
                    ...grouped[groupKey],
                    [key]: item,
                }
            }
        }
        return grouped
    }

    public get siteLocation() {
        return this.value.siteLocation as AosAirport
    }

    public get localisation() {
        return this.value.localisation as AosUserLocalisation
    }

    public get windSpeedUnit(): WeatherUnit {
        return wireToWeatherUnit(this.value.windSpeedUnit)
    }

    public get currentPhone() {
        return this.value.alternativePhoneNumber || this.value.phoneNumber
    }

    public get isFinaviaAuthority() {
        return this.value.isFinaviaAuthority
    }

    public get isAdditionalFinaviaAuthority() {
        return this.value.isAdditionalFinaviaAuthority
    }

    public get dto() {
        return this.value
    }
}
